// extracted by mini-css-extract-plugin
export default {"cta":"uI-z","disabled":"vI-z"};